<template>
  <table class="table table-hover table-responsive align-middle">
    <TableHeader
        :columns="columns"
        :data="data"
        :isSort="isSort"
        :sortDt="sortDt"
        @changeSort="setSort"
        @customEventHeader="handleEventHeader"
    />
    <TableBody
        :columns="columns"
        :data="data"
        :language="language"
        :isLoading="isLoading"
        :rowGeneralClass="rowGeneralClass"
        :rowDynamicClass="rowDynamicClass"
        :hasTotalSumRow="hasTotalSumRow"
        :totalSums="totalSums"
        @onRowClick="onRowClick"
        @customEventBody="handleEventBody"
        @customButtonAction="handleCustomButtonAction"
    />
  </table>

</template>
<script>
import TableHeader from './TableHeader.vue';
import TableBody from './TableBody.vue';

export default {
  props: {
    columns: Array,
    data: Array,
    isSort: Boolean,
    sortDt: Object,
    language: Object,
    isLoading: Boolean,
    rowGeneralClass: String,
    rowDynamicClass: String,
    hasTotalSumRow: Boolean,
    totalSums: Object
  },
  emits: ['onChangeSort', 'onRowClick', 'customEventHeader', 'customEventBody', 'customButtonAction'],
  components: {
    TableHeader,
    TableBody
  },
  methods: {
    setSort(sort) {
      this.$emit('onChangeSort', sort);
    },
    onRowClick(row) {
      this.$emit('onRowClick', row)
    },
    handleEventHeader(event) {
      this.$emit('customEventHeader', event)
    },
    handleEventBody(event) {
      this.$emit('customEventBody', event)
    },
    handleCustomButtonAction(event) {
      this.$emit('customButtonAction', event)
    }
  }
}
</script>